export const MediaNoteGalleryAnswerContainerStyles = () => `
  margin-bottom: 16px;
`;
